import { render } from "./InvoiceBreakdown.vue?vue&type=template&id=1383caf9"
import script from "./InvoiceBreakdown.vue?vue&type=script&lang=js"
export * from "./InvoiceBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__